import React from "react";
import "./Wholesale.css";

export default function Wholesale(): JSX.Element {
  return (
    <main className="wholesale-page">
      <section className="wholesale-hero">
        <h1>Wholesale with Jortel Communications</h1>
        <p>
          Partner with us to deliver Jortel's connectivity, voice, and digital services to your customers.
          We provide the network, you bring the relationships.
        </p>
      </section>

      <section className="wholesale-body">
        <div className="wholesale-card">
          <h2>Why wholesale with Jortel?</h2>
          <ul>
            <li>Access to our mobile, voice, internet, and digital products on competitive rates.</li>
            <li>Local support teams to help you onboard and grow your own brand.</li>
            <li>Flexible packaging so you can tailor offers for different customer segments.</li>
            <li>Billing, provisioning, and number management tools to keep operations simple.</li>
            <li>Marketing assets and co-brand options to help you go-to-market faster.</li>
            <li>Dedicated account team to help you scope opportunities and win deals.</li>
          </ul>

          <h3>What you can deliver</h3>
          <ul>
            <li>Resell voice: SIP, inbound 13/1300/1800, and hosted PBX under your brand.</li>
            <li>Offer connectivity: business-grade NBN, fibre, and mobile data with static IP options.</li>
            <li>Bundle digital: Microsoft/Teams calling, web hosting, design, and social marketing services.</li>
            <li>Add value: packaged support, on-site installs, and managed hardware for your customers.</li>
          </ul>

          <h3>Your role as a wholesaler</h3>
          <ul>
            <li>Own the customer relationship while we supply the network and platform.</li>
            <li>Choose pricing and positioning that fits your market and verticals.</li>
            <li>Brand the services as yours, or co-brand with Jortel where it helps.</li>
            <li>Leverage our provisioning team for porting, activation, and ongoing changes.</li>
          </ul>

          <div className="cta-row">
            <a className="btn-apply" href="/contact?reason=wholesale-application">
              Apply to become a wholesaler
            </a>
          </div>
        </div>

        <div className="wholesale-card login-card">
          <h2>Existing Wholesaler Login</h2>
          <form className="login-form">
            <label>
              Email
              <input type="email" name="email" placeholder="your@email.com" />
            </label>
            <label>
              Password
              <input type="password" name="password" placeholder="Password" />
            </label>
            <button type="submit">Log In</button>
          </form>
          <p className="muted-text">Need access? Contact our team to have your wholesale portal set up.</p>
        </div>
      </section>
    </main>
  );
}
